

export const DEFAULT_STRIPE_PAYMENT_ERROR = 'Failed to Pay';